import { z } from "zod";

export const createAdminExchangeRateFormSchema = z.object({
  fromCurrencyId: z
    .string()
    .min(3, { message: "From currency must be at least 3 characters" }),
  toCurrencyId: z
    .string()
    .min(3, { message: "To currency must be at least 3 characters" }),
  amount: z.number().min(0, { message: "Amount must be a positive number" }),
});

export const updateAdminExchangeRateFormSchema = z.object({
  id: z.string(),
  amount: z
    .string()
    .min(1, { message: "Amount is required" })
    .transform((val) => Number(parseFloat(val).toFixed(2)))
    .refine((val) => val >= 0, { message: "Amount must be a positive number" }),
});

export type createAdminExchangeRateFormValues = z.infer<
  typeof createAdminExchangeRateFormSchema
>;

export type updateAdminExchangeRateFormValues = z.infer<
  typeof updateAdminExchangeRateFormSchema
>;
